import outputList from './outputList';
import outputRefuse from './outputRefuse';
import outputAccept from './outputAccept';
import outputCancel from './outputCancel';
import outputDetail from './outputDetail';
import outputCreate from './outputCreate';
import outputCreateRecord from './outputCreateRecord';
import outputDeleteRecord from './outputDeleteRecord';
import outputMatchRecord from './outputMatchRecord';
import outputStaticsRecord from './outputStaticsRecord';
export default {
    outputList,
    outputRefuse,
    outputAccept,
    outputCancel,
    outputDetail,
    outputCreate,
    outputCreateRecord,
    outputDeleteRecord,
    outputMatchRecord,
    outputStaticsRecord
};



// WEBPACK FOOTER //
// ./src/api/outputSettlement/index.ts